import React, { useRef } from "react";
import Button from "../../../../../server/public/shared/ui/inputs/classicButton.js";
export default function FileUploader(props) {
    var _a;
    const fileInput = useRef(null);
    const extra = {
        multiple: true,
    };
    if (props.singleSelect)
        delete extra.multiple;
    return (React.createElement("label", { className: "input-label file-uploader" },
        React.createElement("input", { type: "file", ref: fileInput, hidden: true, ...extra, onChange: (event) => {
                const files = [...event.target.files];
                const isIncorrect = files.some((file) => file.size >= props.maxSize * 1024 * 1024 ||
                    !props.types.some((type) => type === file.type));
                if (isIncorrect)
                    return props.onFileError("Podano niepoprawny typ pliku.");
                props.onFilesAdded(files);
            } }),
        React.createElement(Button, { text: (_a = props.name) !== null && _a !== void 0 ? _a : "Umieść zdjęcia", value: "add_images", version: "alternative", onClick: () => {
                fileInput.current && fileInput.current.click();
            } })));
}
